import React, { useState } from 'react';
import { LanguageProvider } from '../../../core/language-provider';
import { AuthorizationManager } from '../../../core/authorization-manager';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityConfig from '../../../components/Modals/ModalEntityConfig';
import ModalEntityExport from '../../../components/Modals/ModalEntityExport';
import ModalEntityImport from '../../../components/Modals/ModalEntityImport';


export default function DataGridOptions({ props, data, entity, entityPreferences, entityAllPreferences, updatePreferences, params, searchObj, refreshData }) {


    const [modalEntityConfigStatus, setModalEntityConfigStatus] = useState(false)
    function handleViewUserSettings() {
        setModalEntityConfigStatus(true)
    }
    function closeModalEntityConfig(obj) {
        updatePreferences(obj)
        setModalEntityConfigStatus(false)
    }



    const [modalEntityExportStatus, setModalEntityExportStatus] = useState(false)
    function handleExportExcel() {
        setModalEntityExportStatus(true)
    }
    function closeModalEntityExport() {
        //reload data
        setModalEntityExportStatus(false)
    }



    const [modalEntityImportStatus, setModalEntityImportStatus] = useState(false)
    function handleImportExcel() {
        setModalEntityImportStatus(true)
    }
    function closeModalEntityImport() {
        //reload data
        setModalEntityImportStatus(false)
    }



    if (data && props[entity] !== null) {

        return (
            <>
                <div className='text-end mb-2'>
                    <Dropdown>
                        <Dropdown.Toggle size="sm" variant="outline-secondary">
                            {LanguageProvider.get('defaults.options')}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item className="small datagrid-option-settings" onClick={() => handleViewUserSettings()}>{LanguageProvider.get('defaults.settings')} <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="cog" /></span></Dropdown.Item>
                            <Dropdown.Item className="small datagrid-option-export" onClick={() => handleExportExcel()}>{LanguageProvider.get('defaults.export')} Excel <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="file-download" /></span></Dropdown.Item>
                            {props && props.reference_entity ? (
                                <>
                                    {AuthorizationManager.checkEntityActionAuth(props.reference_entity, 'edit') === true ? (
                                        <Dropdown.Item className="small datagrid-option-import" onClick={() => handleImportExcel()}>{LanguageProvider.get('defaults.import')} Excel <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="file-upload" /></span></Dropdown.Item>
                                    ) : null}
                                </>
                            ) : (
                                <>
                                    {AuthorizationManager.checkEntityActionAuth(entity, 'edit') === true ? (
                                        <Dropdown.Item className="small datagrid-option-import" onClick={() => handleImportExcel()}>{LanguageProvider.get('defaults.import')} Excel <span style={{ width: 30, textAlign: 'center' }} className='ms-3 float-end'><FontAwesomeIcon icon="file-upload" /></span></Dropdown.Item>
                                    ) : null}
                                </>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <ModalEntityConfig entity={entity} props={props} entityPreferences={entityPreferences} entityAllPreferences={entityAllPreferences} status={modalEntityConfigStatus} close={closeModalEntityConfig} />
                <ModalEntityExport entity={entity} props={props} entityPreferences={entityPreferences} status={modalEntityExportStatus} close={closeModalEntityExport} params={params} searchObj={searchObj} />


                {props && props.reference_entity ? (
                    <>
                        {AuthorizationManager.checkEntityActionAuth(props.reference_entity, 'edit') === true ? (
                            <ModalEntityImport entity={props.reference_entity} props={props} status={modalEntityImportStatus} close={closeModalEntityImport} refreshData={refreshData} />
                        ) : null}
                    </>
                ) : (
                    <>
                        {AuthorizationManager.checkEntityActionAuth(entity, 'edit') === true ? (
                            <ModalEntityImport entity={entity} props={props} entityPreferences={entityPreferences} status={modalEntityImportStatus} close={closeModalEntityImport} refreshData={refreshData} />
                        ) : null}
                    </>
                )}

            </>
        );
    }
};